// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__84svh","options":"AnswerScale_options__2T40x","selected":"AnswerScale_selected__2eHTZ"};